module.exports = __webpack_public_path__ + "img/screen-share.2e1f976.svg";